import { Button, H3, P } from 'konsys-ui'
import * as React from 'react'
import {
  Checkbox, Input, message, Select,
} from 'antd'
import { useLazyQuery, useMutation } from '@apollo/react-hooks'
import _, { isNil } from 'lodash'
import moment from 'moment-timezone'
import { theme } from '../../../styles/_variables'
import { GAS_STATION_LIST } from '../../../constants/graphql/query'
import { fuelTypeList } from '../detail/component-renderer'
import { DatePickerWithLabel, InputWithLabelBlock } from '../../../components/shipping-order-components'
import { specialReason } from '../constants'
import { isNilOrEmptyString } from '../../../utils/util-services'
import { CREATE_FUEL_ORDER } from '../../../constants/graphql/mutation'

const { color } = theme

const Label = ({ label, required, children }) => (
  <div className='flex flex-col gap-y-4'>
    <P>{label} {required && '*'}</P>
    {children}
  </div>
)

const Index = () => {
  const [formData, setFormData] = React.useState({ isPaidByFleetCard: true })
  const [selectedGasStation, setSelectedGasStation] = React.useState(null)

  const [fetchGasStations, { data: gasStationList, loading: gasStationListLoading }] = useLazyQuery(GAS_STATION_LIST)
  const gasStationOptions = gasStationList?.GasstationList?.lists?.map(station => ({ id: station.id, name: station.name })) || []

  const [create, { data, loading }] = useMutation(CREATE_FUEL_ORDER)

  const handleChange = (key, value, isFloat) => {
    setFormData({
      ...formData,
      [key]: isFloat ? parseFloat(value) : value,
    })
  }

  const handleSelectGasStation = (id) => {
    const gasStation = gasStationList?.GasstationList?.lists?.find(station => station.id === _.parseInt(id))
    if (gasStation) {
      setSelectedGasStation(gasStation)
      handleChange('gasstationId', gasStation.id)
    }
  }

  const handleSelectFuelType = (value) => {
    const fuelType = fuelTypeList.find(type => type.value === value)
    if (fuelType) {
      handleChange('fuelType', fuelType.value)
    }
  }

  const handleCreate = async () => {
    const response = await create({
      variables: {
        input: formData,
      },
    })

    const resp = response.data?.CreateFuelOrder
    if (resp?.success) {
      message.success(resp.message)
    } else {
      message.error(resp.error)
    }
  }

  const isFormValid = (
    !isNil(formData.gasstationId)
    && !isNil(formData.totalAmount)
    && !isNil(formData.fuelType)
    && !isNil(formData.kmPerLitre)
    && !isNil(formData.expiredDate)
    && !isNil(formData.specialReason)
    && (formData.specialReason !== specialReason.OTHER.value || !isNilOrEmptyString(formData.specialReasonOther))
  )

  React.useEffect(() => {
    fetchGasStations({ name: '', isActive: true })
  }, [])

  React.useEffect(() => {
    if (!formData.specialReason || formData.specialReason !== specialReason.OTHER.value) {
      setFormData({
        ...formData,
        specialReasonOther: '',
      })
    }
  }, [formData.specialReason])

  return (
    <main>
      <H3 bold color={color.primaryColor} margin='32px 0'>สร้างใบเบิกน้ำมันพิเศษ</H3>
      <div className='grid grid-cols-3 gap-3'>
        <div className='col-span-3 mb-2'>
          <Checkbox
            onChange={e => handleChange('isPaidByFleetCard', e.target.checked)}
            defaultChecked
          >
            จ่ายเงินด้วย FleetCard
          </Checkbox>
        </div>
        <Label label='ปั๊มน้ำมัน' required>
          <Select
            loading={gasStationListLoading}
            className='w-full'
            placeholder='พิมพ์รหัสปั๊มน้ำมัน'
            showSearch
            onSearch={search => fetchGasStations({ name: search, isActive: true })}
            onChange={handleSelectGasStation}
          >
            {
              gasStationOptions.map(option => (
                <Select.Option key={option.id} value={option.id}>
                  {option.name}
                </Select.Option>
              ))
            }
          </Select>
        </Label>
        <Label label='รหัสปั๊มน้ำมัน'>
          <P>{selectedGasStation?.code || '-'}</P>
        </Label>
        <Label label='บริษัท'>
          <P>{selectedGasStation?.company || '-'}</P>
        </Label>
        <InputWithLabelBlock
          isFloat
          data={{
            id: 'totalAmount',
            value: formData.totalAmount,
            props: { title: { text: 'ปริมาณทั้งหมด (ลิตร) *' } },
          }}
          onChangeHandler={handleChange}
        />
        <Label label='ประเภทเชื้อเพลิง' required>
          <Select
            className='w-full'
            placeholder='เลือกประเภทเชื้อเพลิง'
            onChange={handleSelectFuelType}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            optionFilterProp='children'
            showSearch
          >
            {fuelTypeList.map(type => (
              <Select.Option key={type.value} value={type.value}>{type.text}</Select.Option>
            ))}
          </Select>
        </Label>
        <InputWithLabelBlock
          isFloat
          data={{
            value: formData.kmPerLitre,
            id: 'kmPerLitre',
            props: { title: { text: 'อัตราเผาผลาญ (กิโลเมตร/ลิตร) *' } },
          }}
          onChangeHandler={handleChange}
        />
        <DatePickerWithLabel
          disabledDate={current => current && current < moment().subtract(1, 'd').endOf('day')}
          data={{
            id: 'expiredDate',
            defaultValue: undefined,
            value: !_.isUndefined(formData.expiredDate) ? moment(formData.expiredDate) : undefined,
            text: 'วันหมดอายุ *',
          }}
          onChangeHandler={handleChange}
        />
        <Label label='สถานะ'>
          <P>ยังไม่ได้สร้าง</P>
        </Label>
        <Label label='ปริมาณที่เติมแล้ว'>
          <P>- ลิตร</P>
        </Label>
        <Label label='เหตุผล' required>
          <Select
            onChange={value => handleChange('specialReason', value)}
            placeholder='เลือกเหตุผล'
          >
            {
              Object.keys(specialReason).map(key => (
                <Select.Option
                  value={specialReason[key].value}
                  key={specialReason[key].value}
                >
                  {specialReason[key]?.label}
                </Select.Option>
              ))
            }
          </Select>
        </Label>
        <Label label='เหตุผลอื่น ๆ'>
          <Input
            disabled={formData.specialReason !== specialReason.OTHER.value}
            placeholder='กรอกเหตุผล'
            onChange={e => handleChange('specialReasonOther', e.target.value)}
            value={formData.specialReasonOther}
          />
        </Label>
      </div>
      <footer
        className='fixed bottom-0 left-0 h-18 w-screen flex! justify-end items-center px-8'
        style={{ backgroundColor: `rgba(${color.primaryColorRGB}, 0.2)` }}
      >
        <Button
          disabled={!isFormValid}
          onClick={handleCreate}
          text='สร้างใบเบิกน้ำมันพิเศษ'
        />
      </footer>
    </main>
  )
}

export default Index
